export default __webpack_public_path__ + "youtube-sqr-v1.svg";